import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
// import Switch from '@material-ui/core/Switch';
// import Paper from '@material-ui/core/Paper';
// import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 'auto',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  text: {
      height: '100%',
  },
  paper: {
    margin: theme.spacing(1),
  },
}));

const getIndexAt3Sentences = (text) => {
  const punctuation = ["!", ".", "?"];
  let puncArray = [];

  punctuation.forEach((symbol,index) => {
    var a=[],i=-1;
    while((i=text.indexOf(symbol,i+1)) >= 0) a.push(i);
    puncArray.push(...a);
  })

  puncArray.sort((a,b) => a - b);

  return puncArray[2];
};

export default function SimpleCollapse(props) {
  const { description } = props;
  const classes = useStyles();
  const [checked, setChecked] = React.useState(false);

  const handleChange = () => {
    setChecked((prev) => !prev);
  };

  return (
    <div className={classes.root}>
      <div className={classes.container}>
      <p>{ description.substring(0,getIndexAt3Sentences(description) + 1)}</p>
        <Collapse in={checked} collapsedsize={200}>
            <p className={classes.text}>
                {description.substring(getIndexAt3Sentences(description) + 1)}
            </p>
          {/* <Paper elevation={4} className={classes.paper}>
            <svg className={classes.svg}>
              <polygon points="0,100 50,00, 100,100" className={classes.polygon} />
            </svg>
          </Paper> */}
        </Collapse>
      </div>

      <button className="u-margin-top-tiny product__readmore" onClick={handleChange}>
          {checked ? 'READ LESS' : 'READ MORE...'}
      </button>
    </div>
  );
}